import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { useAuth } from '@context';
import { canAccessAdminPanel, hasCapability, isAdmin } from '@utils/permissions';

/**
 * RequireAdmin Component
 * Restricts access to admin users (those with admin-level capabilities)
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components to render if authorized
 * @param {string|null} props.requiredCapability - Specific capability to require (optional)
 * @param {boolean} props.adminOnly - Restrict access to admin role only
 */
export function RequireAdmin({ children, requiredCapability = null, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  let hasAccess = false;

  if (adminOnly) {
    hasAccess = isAdmin(user);
  } else if (requiredCapability) {
    hasAccess = hasCapability(user, requiredCapability);
  } else {
    hasAccess = canAccessAdminPanel(user);
  }

  if (!hasAccess) {
    return (
      <Container className="py-5">
        <Alert variant="danger" className="mb-3">
          Unauthorized: Admin access required.
        </Alert>
        <div className="text-center">
          <Button variant="primary" href="/">Return Home</Button>
        </div>
      </Container>
    );
  }

  return children;
}
